module.exports = __webpack_public_path__ + "static/media/usdt-color.aac39851.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/usdt-color.svg
// module id = 2391
// module chunks = 7